import FileDetails from './FileDetails';

export default FileDetails;
